module.exports = __webpack_public_path__ + "img/user.25ec8f6a.svg";